import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getRoles = async ({ commit }) => {
  commit('setRolIsLoading', true);
  let url = `/roles/selectable`;

  await connection.get(url)
    .then(res => {
      const roles = res.data.data;
      commit('setRolesSelectable', roles);
      commit('setRolIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setRolIsLoading', false);
    });
}

export const loadRoles = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setRolIsLoading', true);
    let url = `/roles`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        const roles = res.data.data;
        commit('setRoles', roles);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setRolesPaginated', res.data);
        commit('setRolIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setRolIsLoading', false);
      });
}

export const rolById = async ({ commit }, id) => {
  commit('setRolIsLoading', true);
  await connection.get(`/roles/${id}`)
    .then(res => {
      commit('setRolDetail', res.data.data);
      commit('setRolIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setRolIsLoading', false);
    });
}

export const storeRol = async ({ commit }, rol) => {
  commit('setRolIsCreating', true);
  await connection.post(`/roles/create`, rol)
    .then(res => {
      console.log(res.data);
      commit('saveNewRoles', res.data);
      commit('setRolIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setRolIsCreating', false);
    });
}

export const updateRol = async ({ commit }, rol ) => {
  commit('setRolIsUpdating', true);
  await connection.put(`/roles/${rol.id}/update`, rol)
    .then(res => {
      commit('saveUpdatedRol', res.data);
      commit('setRolIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setRolIsUpdating', false);
    });
}

export const deleteRol = async ({ commit }, rol) => {
  commit('setRolIsDeleting', true);
  await connection.delete(`/roles/${rol.id}/delete`)
    .then(res => {
      commit('setDeleteRol', res.data);
      commit('setRolIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setRolIsDeleting', false);
    });
}
